import AboutUs from "../AboutUs/AboutUs";
import Agreement from "../Agreement/Agreement";
import ConfirmMail from "../Auth/pages/ConfirmMail";
import ForgotPassword from "../Auth/pages/ForgotPassword";
import Login from "../Auth/pages/Login";
import Register from "../Auth/pages/Register";
import ResetPassword from "../Auth/pages/ResetPassword";
import Cart from "../Cart/Cart";
import Payment from "../Cart/Payment";
import PaymentComplete from "../Cart/PaymentComplete";
import PaymentResult from "../Cart/PaymentResult";
import ContactUs from "../ContactUs/ContactUs";
import ContactWith from "../ContactWith/ContactWith";
import AdditionalCourses from "../Courses/AdditionalCourses/AdditionalCourses";
import Course from "../Courses/Course/Course";
import Watching from "../Courses/Course/Watching";
import CustomCourses from "../Courses/CustomCourses/CustomCourses";
import SubCourses from "../Courses/SubCourses/SubCourses";
import CreateAccount from "../CreateAccount/CreateAccount";
import Explore from "../Explore/Explore";
import Help from "../Help/Help";
import Home from "../Home/Home";
import Index from "../Index/Index";
import Instructor from "../Instructors/Instructor";
import Instructors from "../Instructors/Instructors";
import BillingInfo from "../Profile/pages/BillingInfo";
import ChangePassword from "../Profile/pages/ChangePassword";
import ContactPermission from "../Profile/pages/ContactPermission";
import Payments from "../Profile/pages/Payments";
import ProfileInfo from "../Profile/pages/ProfileInfo";
import Subscription from "../Subscription/Subscription";
import WorkshopDetail from "../Workshop/Detail/WorkshopDetail";

export const auth = [
  {
    id: "profile-info",
    name: "Profil Bilgilerim",
    property: ProfileInfo,
    link: "/profil-bilgilerim",
    onProfileMenu: true,
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="15.5" stroke="#081720" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6296 14.9197C17.1036 15.2663 16.5228 15.4396 15.887 15.4396C15.2513 15.4396 14.6704 15.2678 14.1444 14.924C13.6184 14.5803 13.1993 14.1214 12.887 13.5476C12.5748 12.9737 12.4187 12.3374 12.4187 11.6385C12.4131 10.951 12.5678 10.326 12.8828 9.76349C13.1979 9.20099 13.6184 8.75213 14.1444 8.4169C14.6704 8.08168 15.2513 7.91406 15.887 7.91406C16.5284 7.91406 17.1121 8.08026 17.6381 8.41264C18.1641 8.74503 18.5832 9.19105 18.8955 9.75071C19.2077 10.3104 19.3638 10.9339 19.3638 11.6214C19.3638 12.3203 19.2063 12.9581 18.8913 13.5348C18.5762 14.1115 18.1557 14.5732 17.6296 14.9197ZM14.8448 13.7905C15.1627 14.0092 15.5101 14.1186 15.887 14.1186C16.2696 14.1186 16.6184 14.0078 16.9334 13.7862C17.2485 13.5646 17.5017 13.2649 17.6929 12.8871C17.8842 12.5092 17.9799 12.0874 17.9799 11.6214C17.9799 11.1726 17.8856 10.7678 17.6972 10.407C17.5087 10.0462 17.2569 9.76065 16.9419 9.55043C16.6268 9.3402 16.2752 9.23509 15.887 9.23509C15.5045 9.23509 15.1543 9.34162 14.8364 9.55469C14.5185 9.76776 14.2654 10.0561 14.0769 10.4197C13.8884 10.7834 13.7942 11.1896 13.7942 11.6385C13.7942 12.1044 13.8898 12.5249 14.0811 12.8999C14.2724 13.2749 14.527 13.5717 14.8448 13.7905ZM20.8744 22.9141C22.2133 22.9141 22.8828 22.468 22.8828 21.576C22.8828 21.0305 22.7211 20.4595 22.3976 19.8629C22.0741 19.2663 21.6071 18.7053 20.9967 18.1797C20.3863 17.6541 19.6507 17.2266 18.79 16.897C17.9292 16.5675 16.9616 16.4027 15.887 16.4027C14.8069 16.4027 13.8364 16.5675 12.9756 16.897C12.1149 17.2266 11.3793 17.6541 10.7689 18.1797C10.1585 18.7053 9.69153 19.2663 9.36804 19.8629C9.04456 20.4595 8.88281 21.0305 8.88281 21.576C8.88281 22.468 9.55229 22.9141 10.8913 22.9141H20.8744ZM10.579 21.593H21.1866C21.2879 21.593 21.3596 21.5774 21.4018 21.5462C21.444 21.5149 21.4651 21.4595 21.4651 21.38C21.4651 21.0675 21.3427 20.7024 21.098 20.2848C20.8533 19.8672 20.4932 19.4652 20.0178 19.0788C19.5424 18.6925 18.9588 18.37 18.2668 18.1115C17.5748 17.853 16.7815 17.7237 15.887 17.7237C14.9925 17.7237 14.1979 17.853 13.5031 18.1115C12.8083 18.37 12.2232 18.6925 11.7478 19.0788C11.2724 19.4652 10.9138 19.8672 10.6718 20.2848C10.4299 20.7024 10.309 21.0675 10.309 21.38C10.309 21.4595 10.3301 21.5149 10.3723 21.5462C10.4145 21.5774 10.4834 21.593 10.579 21.593Z"
          fill="#081720"
        />
      </svg>
    ),
  },
  {
    id: "change-password",
    name: "Şifremi Değiştir",
    property: ChangePassword,
    link: "/sifremi-degistir",
    onProfileMenu: true,
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3653 22.1875C19.9205 22.1875 20.333 22.0491 20.6029 21.7724C20.8728 21.4957 21.0078 21.0657 21.0078 20.4824V15.5166C21.0078 14.9382 20.8728 14.5107 20.6029 14.234C20.423 14.0495 20.1796 13.9265 19.8729 13.865L19.7235 13.8416L19.7244 12.1587C19.7244 11.4906 19.6225 10.9085 19.4188 10.4124C19.2151 9.91631 18.9363 9.50374 18.5823 9.17468C18.2283 8.84562 17.8298 8.59882 17.3867 8.43429C16.9436 8.26976 16.4853 8.1875 16.0116 8.1875C15.5329 8.1875 15.072 8.26976 14.6289 8.43429C14.1858 8.59882 13.7886 8.84562 13.4371 9.17468C13.0857 9.50374 12.8069 9.91631 12.6006 10.4124C12.3944 10.9085 12.2912 11.4906 12.2912 12.1587L12.2909 13.8425L12.1503 13.865C11.847 13.9265 11.6037 14.0495 11.4203 14.234C11.1453 14.5107 11.0078 14.9382 11.0078 15.5166V20.4824C11.0078 21.0657 11.1453 21.4957 11.4203 21.7724C11.6954 22.0491 12.1053 22.1875 12.6503 22.1875H19.3653ZM18.4406 13.8196H13.5739L13.5747 12.0166C13.5747 11.4482 13.6867 10.9683 13.9108 10.5769C14.1349 10.1855 14.4315 9.89014 14.8008 9.69071C15.17 9.49127 15.5736 9.39156 16.0116 9.39156C16.4496 9.39156 16.852 9.49127 17.2187 9.69071C17.5854 9.89014 17.8807 10.1855 18.1048 10.5769C18.3289 10.9683 18.441 11.4482 18.441 12.0166L18.4406 13.8196ZM12.8031 21.0059H19.2355C19.3933 21.0059 19.5118 20.966 19.5907 20.8862C19.6696 20.8064 19.7091 20.6718 19.7091 20.4824V15.5166C19.7091 15.3271 19.6696 15.1925 19.5907 15.1127C19.5118 15.0329 19.3933 14.9931 19.2355 14.9931H12.8031C12.635 14.9931 12.5102 15.0329 12.4287 15.1127C12.3473 15.1925 12.3065 15.3271 12.3065 15.5166V20.4824C12.3065 20.6718 12.3473 20.8064 12.4287 20.8862C12.5102 20.966 12.635 21.0059 12.8031 21.0059Z"
          fill="#081720"
        />
        <circle cx="16" cy="16" r="15.5" stroke="black" />
      </svg>
    ),
  },
  {
    id: "billing-info",
    name: "Fatura Bilgilerim",
    property: BillingInfo,
    link: "/fatura-bilgilerim",
    onProfileMenu: true,
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7551 24C20.5009 24 21.0615 23.8 21.4369 23.4C21.8123 23 22 22.4052 22 21.6157V10.3922C22 9.60261 21.8123 9.00654 21.4369 8.60392C21.0615 8.20131 20.5009 8 19.7551 8H12.2449C11.504 8 10.9447 8.20131 10.5668 8.60392C10.1889 9.00654 10 9.60261 10 10.3922V21.6157C10 22.4052 10.1889 23 10.5668 23.4C10.9447 23.8 11.504 24 12.2449 24H19.7551ZM19.6582 22.651H12.3418C11.9938 22.651 11.7303 22.5569 11.5513 22.3686C11.3723 22.1804 11.2828 21.9085 11.2828 21.5529V10.4549C11.2828 10.0993 11.3723 9.82745 11.5513 9.63922C11.7303 9.45098 11.9938 9.35686 12.3418 9.35686H19.6582C20.0162 9.35686 20.2834 9.45098 20.4599 9.63922C20.6364 9.82745 20.7247 10.0993 20.7247 10.4549V21.5529C20.7247 21.9085 20.6364 22.1804 20.4599 22.3686C20.2834 22.5569 20.0162 22.651 19.6582 22.651ZM18.9534 12.2902C18.8713 12.3843 18.7657 12.4314 18.6364 12.4314H13.3934C13.2641 12.4314 13.1572 12.3843 13.0727 12.2902C12.9882 12.1961 12.9459 12.0837 12.9459 11.9529C12.9459 11.8275 12.9882 11.7203 13.0727 11.6314C13.1572 11.5425 13.2641 11.498 13.3934 11.498H18.6364C18.7657 11.498 18.8713 11.5425 18.9534 11.6314C19.0354 11.7203 19.0764 11.8275 19.0764 11.9529C19.0764 12.0837 19.0354 12.1961 18.9534 12.2902ZM18.6364 14.9882C18.7657 14.9882 18.8713 14.9425 18.9534 14.851C19.0354 14.7595 19.0764 14.6458 19.0764 14.5098C19.0764 14.3843 19.0354 14.2771 18.9534 14.1882C18.8713 14.0993 18.7657 14.0549 18.6364 14.0549H13.3934C13.2641 14.0549 13.1572 14.0993 13.0727 14.1882C12.9882 14.2771 12.9459 14.3843 12.9459 14.5098C12.9459 14.6458 12.9882 14.7595 13.0727 14.851C13.1572 14.9425 13.2641 14.9882 13.3934 14.9882H18.6364ZM16.2275 17.4078C16.1429 17.4941 16.036 17.5373 15.9068 17.5373H13.3934C13.2641 17.5373 13.1572 17.4941 13.0727 17.4078C12.9882 17.3216 12.9459 17.2131 12.9459 17.0824C12.9459 16.9516 12.9882 16.8405 13.0727 16.749C13.1572 16.6575 13.2641 16.6118 13.3934 16.6118H15.9068C16.036 16.6118 16.1429 16.6575 16.2275 16.749C16.312 16.8405 16.3543 16.9516 16.3543 17.0824C16.3543 17.2131 16.312 17.3216 16.2275 17.4078Z"
          fill="#081720"
        />
        <circle cx="16" cy="16" r="15.5" stroke="black" />
      </svg>
    ),
  },
  {
    id: "payments",
    name: "Ödemelerim",
    property: Payments,
    link: "/odemelerim",
    onProfileMenu: true,
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.5458 23C23.3612 23 23.9741 22.7979 24.3844 22.3937C24.7948 21.9896 25 21.3913 25 20.5989V11.4011C25 10.6087 24.7948 10.0104 24.3844 9.60627C23.9741 9.20209 23.3612 9 22.5458 9H9.45418C8.64417 9 8.03263 9.20076 7.61958 9.60228C7.20653 10.0038 7 10.6034 7 11.4011V20.5989C7 21.3966 7.20653 21.9962 7.61958 22.3977C8.03263 22.7992 8.64417 23 9.45418 23H22.5458ZM23.6154 11.6729H8.38342L8.384 11.5048C8.384 11.1273 8.4819 10.8427 8.67769 10.6513C8.87349 10.4598 9.1511 10.3641 9.51051 10.3641H22.4895C22.8489 10.3641 23.1265 10.4598 23.3223 10.6513C23.5181 10.8427 23.616 11.1273 23.616 11.5048L23.6154 11.6729ZM9.51051 21.6359H22.4895C22.8489 21.6359 23.1265 21.5402 23.3223 21.3487C23.5181 21.1573 23.616 20.8727 23.616 20.4952L23.6154 12.8053H8.38342L8.384 20.4952C8.384 20.8727 8.4819 21.1573 8.67769 21.3487C8.87349 21.5402 9.1511 21.6359 9.51051 21.6359Z"
          fill="#081720"
        />
        <circle cx="16" cy="16" r="15.5" stroke="black" />
      </svg>
    ),
  },
  {
    id: "contact-permission",
    name: "İletişim İzinlerim",
    property: ContactPermission,
    link: "/iletisim-izinlerim",
    onProfileMenu: true,
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.5078 13.7617C23.1224 13.9935 22.6953 14.1094 22.2266 14.1094C21.7578 14.1094 21.3307 13.9935 20.9453 13.7617C20.5599 13.5299 20.2513 13.2214 20.0195 12.8359C19.7878 12.4505 19.6719 12.0234 19.6719 11.5547C19.6719 11.0859 19.7878 10.6589 20.0195 10.2734C20.2513 9.88802 20.5599 9.57943 20.9453 9.34766C21.3307 9.11589 21.7578 9 22.2266 9C22.6953 9 23.1224 9.11589 23.5078 9.34766C23.8932 9.57943 24.2018 9.88802 24.4336 10.2734C24.6654 10.6589 24.7812 11.0859 24.7812 11.5547C24.7812 12.0234 24.6654 12.4505 24.4336 12.8359C24.2018 13.2214 23.8932 13.5299 23.5078 13.7617ZM22.9023 22.5859C22.5195 22.9818 21.9818 23.1797 21.2891 23.1797H9.38281C8.59635 23.1797 8.0026 22.9818 7.60156 22.5859C7.20052 22.1901 7 21.6016 7 20.8203V12.6641C7 11.888 7.19141 11.3008 7.57422 10.9023C7.95703 10.5039 8.49479 10.3047 9.1875 10.3047H18.8672C18.7891 10.5026 18.7318 10.7109 18.6953 10.9297C18.6589 11.1484 18.6458 11.3672 18.6562 11.5859H9.36719C9.2154 11.5859 9.07868 11.6029 8.95703 11.6369L8.91319 11.6523L14.3828 17.0547C14.5443 17.2109 14.694 17.3229 14.832 17.3906C14.9701 17.4583 15.1094 17.4922 15.25 17.4922C15.3906 17.4922 15.5312 17.4583 15.6719 17.3906C15.8125 17.3229 15.9609 17.2109 16.1172 17.0547L19.4375 13.7812C19.5573 13.9375 19.6901 14.0833 19.8359 14.2188C19.9818 14.3542 20.138 14.474 20.3047 14.5781L18.1112 16.7323L22.2102 20.7943L22.2109 15.125C22.4297 15.1302 22.6458 15.1146 22.8594 15.0781C23.0729 15.0417 23.2786 14.9844 23.4766 14.9062V20.8203C23.4766 21.6016 23.2852 22.1901 22.9023 22.5859ZM8.26619 20.8243L8.26562 20.7969V12.6875L8.26519 12.6863L12.3892 16.7403L8.26619 20.8243ZM9.36719 21.9062H21.1094C21.2589 21.9062 21.3941 21.8893 21.515 21.8553L21.5732 21.8353L17.2632 17.5653L16.8203 18C16.5599 18.2604 16.2995 18.4479 16.0391 18.5625C15.7786 18.6771 15.5156 18.7344 15.25 18.7344C14.9792 18.7344 14.7148 18.6771 14.457 18.5625C14.1992 18.4479 13.9375 18.2604 13.6719 18L13.2322 17.5683L8.91319 21.8403L8.95703 21.8553C9.07868 21.8893 9.2154 21.9062 9.36719 21.9062Z"
          fill="#081720"
        />
        <circle cx="16" cy="16" r="15.5" stroke="black" />
      </svg>
    ),
  },
  {
    id: "payment",
    name: "Ödeme Sayfası",
    property: Payment,
    link: "/odeme",
    onProfileMenu: false,
  },
  {
    id: "payment-complete",
    name: "Ödeme Tamamlandı",
    property: PaymentComplete,
    link: "/odeme-tamamlandi",
    onProfileMenu: false,
  },
  {
    id: "payment-result",
    name: "Ödeme Sonucu",
    property: PaymentResult,
    link: "/payment-result",
    onProfileMenu: false,
  },
  {
    id: "course",
    name: "Eğitim Detay",
    property: Course,
    link: "/:category/egitim/:slug",
    exact: true,
    inMenu: false,
    inFooterMenu: false,
    onProfileMenu: false,
    includedCategories: [],
  },
  {
    id: "additional-course",
    name: "Eğitim Detay",
    property: Course,
    link: "/:category/ek-egitim/:slug",
    exact: true,
    inMenu: false,
    inFooterMenu: false,
    onProfileMenu: false,
    includedCategories: [],
  },
  {
    id: "course-watching",
    name: "Eğitim İzleniyor",
    property: Watching,
    link: "/:category/egitim/:course/:chapter/:slug",
    exact: true,
    inMenu: false,
    inFooterMenu: false,
    onProfileMenu: false,
    includedCategories: [],
  },
];

export const guest = [
  {
    id: "login",
    name: "Giriş Yap",
    property: Login,
    link: "/giris-yap",
  },
  {
    id: "register",
    name: "Üye ol",
    property: Register,
    link: "/uye-ol",
  },
  {
    id: "forgotpass",
    name: "Şifremi Unuttum",
    property: ForgotPassword,
    link: "/sifremi-unuttum",
  },
  {
    id: "resetpass",
    name: "Şifre Oluşturma",
    property: ResetPassword,
    link: "/sifre-olustur",
  },
];

export const global = [
  {
    id: "home",
    name: "Anasayfa",
    property: Home,
    link: "/",
    exact: true,
    inMenu: false,
    inFooterMenu: false,
    onProfileMenu: false,
  },
  {
    id: "workshop",
    name: "Workshop",
    property: CustomCourses,
    link: "/workshop",
    exact: true,
    inMenu: false,
    inFooterMenu: false,
    onProfileMenu: false,
  },
  {
    id: "workshop-detail",
    name: "Workshop Detay",
    property: WorkshopDetail,
    link: "/workshop/:slug",
    exact: true,
    inMenu: false,
    inFooterMenu: false,
    onProfileMenu: false,
  },
  {
    id: "index",
    name: "Index",
    property: Index,
    link: "/:category",
    exact: true,
    inMenu: false,
    inFooterMenu: false,
    inTopMenu: false,
    inCorporateMenu: false,
    defaultParams: [{ key: "category", value: "icerik-ureticiligi" }],
    pages: [
      {
        id: "explore",
        name: "Keşfet",
        property: Explore,
        link: "kesfet",
        exact: true,
        inMenu: true,
        inFooterMenu: true,
        inTopMenu: true,
        inCorporateMenu: true,
        order: 1,
        includedCategories: [],
      },
      {
        id: "contact-explore",
        name: "İletişime Geç",
        property: ContactWith,
        link: ":page/iletisime-gec",
        includedCategories: [],
      },
      {
        id: "contact-courses",
        name: "İletişime Geç",
        property: ContactWith,
        link: ":page/:slug?/iletisime-gec",
        includedCategories: [],
      },
      {
        id: "courses",
        name: "Eğitimler",
        property: SubCourses,
        link: "egitimler/:slug?",
        defaultParams: [{ key: "slug?", value: "" }],
        exact: false,
        inMenu: true,
        inFooterMenu: true,
        activeWith: ["course"],
        inTopMenu: true,
        order: 2,
        includedCategories: ["icerik-ureticiligi", "muzik", "oyunculuk"],
      },

      {
        id: "online-courses",
        name: "Online Eğitimler",
        property: SubCourses,
        link: "online-egitimler/:slug?",
        defaultParams: [{ key: "slug?", value: "" }],
        exact: false,
        inTopMenu: true,
        inCorporateMenu: true,
        inFooterMenu: true,
        order: 2,
        activeWith: ["course"],
        includedCategories: ["kurumsal"],
      },
      {
        id: "face-to-face-courses",
        name: "Yüz Yüze Eğitimler",
        property: CustomCourses,
        link: "yuz-yuze-egitimler/:slug?",
        defaultParams: [{ key: "slug?", value: "" }],
        exact: false,
        inTopMenu: true,
        inCorporateMenu: true,
        inFooterMenu: true,
        order: 3,
        includedCategories: ["kurumsal"],
      },
      {
        id: "crowd-management",
        name: "Topluluk Yönetimi",
        property: CustomCourses,
        link: "topluluk-yonetimi/:slug?",
        defaultParams: [{ key: "slug?", value: "" }],
        exact: false,
        inTopMenu: true,
        inCorporateMenu: true,
        inFooterMenu: true,
        order: 4,
        includedCategories: ["kurumsal"],
      },
      {
        id: "narrators",
        name: "Konuşmacılar",
        property: Instructors,
        link: "konusmacilar",
        exact: true,
        activeWith: ["narrators", "instructor"],
        inTopMenu: true,
        inCorporateMenu: true,
        inFooterMenu: true,
        order: 5,
        includedCategories: ["kurumsal"],
      },
      {
        id: "instructors",
        name: "Eğitmenler",
        property: Instructors,
        link: "egitmenler",
        exact: true,
        inMenu: true,
        inFooterMenu: true,
        activeWith: ["narrators", "instructor"],
        inTopMenu: true,
        order: 4,
        includedCategories: ["icerik-ureticiligi", "muzik", "oyunculuk"],
      },
      {
        id: "instructor",
        name: "Eğitmen",
        property: Instructor,
        link: "egitmen/:slug",
        exact: true,
        inMenu: false,
        inFooterMenu: false,
        includedCategories: [],
      },
      {
        id: "subscription",
        name: "Satın Al",
        property: Subscription,
        link: "fiyatlandirma",
        exact: true,
        inMenu: true,
        inFooterMenu: true,
        inTopMenu: true,
        order: 5,
        includedCategories: ["icerik-ureticiligi", "muzik", "oyunculuk"],
      },
      {
        id: "help",
        name: "Yardım",
        property: Help,
        link: "yardim",
        exact: true,
        inMenu: true,
        inFooterMenu: true,
        inTopMenu: true,
        inCorporateMenu: true,
        order: 6,
        includedCategories: [],
      },
    ],
  },
  {
    id: "create-account",
    name: "Hesap Oluştur",
    property: CreateAccount,
    link: "/hesap-olustur",
    exact: true,
    inMenu: false,
    inFooterMenu: false,
    inTopMenu: false,
    inCorporateMenu: false,
    includedCategories: [],
  },
  {
    id: "additional-courses",
    name: "Ek Eğitimler",
    property: AdditionalCourses,
    link: "/ek-egitimler",
    exact: true,
    inMenu: false,
    inFooterMenu: false,
    activeWith: ["additionalCourse"],
  },
  {
    id: "about-us",
    name: "Hakkımızda",
    property: AboutUs,
    link: "/hakkimizda",
    exact: true,
    inMenu: false,
    inFooterMenu: true,
  },
  {
    id: "contact-us",
    name: "İletişime Geçin",
    property: ContactUs,
    link: "/iletisim",
    exact: true,
    inMenu: false,
    inFooterMenu: true,
  },
  {
    id: "agreement-page",
    name: "",
    property: Agreement,
    link: "/sozlesme/:name",
    exact: true,
  },
  {
    id: "cart",
    name: "Alışveriş Çantam",
    property: Cart,
    link: "/alisveris-cantam",
    exact: true,
  },
  {
    id: "confirm",
    name: "Doğrulama",
    property: ConfirmMail,
    link: "/dogrulama",
  },
];

export const callback = [];

export const topMenu = [
  {
    id: "topmenu-content-creation",
    name: "İçerik Üreticiliği",
    link: "icerik-ureticiligi",
    defaultParams: "/kesfet",
    hasSubNav: true,
    visible: true,
  },
  {
    id: "topmenu-music",
    name: "Müzik",
    link: "muzik",
    defaultParams: "/kesfet",
    hasSubNav: true,
    visible: true,
  },
  {
    id: "topmenu-acting",
    name: "Oyunculuk",
    link: "oyunculuk",
    defaultParams: "/kesfet",
    hasSubNav: true,
    visible: true,
  },
  {
    id: "topmenu-corporate",
    name: "Kurumsal",
    link: "kurumsal",
    defaultParams: "/kesfet",
    hasSubNav: true,
    visible: false,
  },
  {
    id: "topmenu-workshop",
    name: "Workshop",
    link: "workshop",
    defaultParams: "",
    hasSubNav: false,
    visible: true,
  },
];
